import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { SCTooltip } from 'rollup-allspark';
import { getMetric } from '../config/metricGlossary';
import MetricDrawer from './MetricDrawer';

/**
 * Metric explanation affordance (tiers 1 + 2).
 *  - Hover the info icon  → SCTooltip with the one-line `short` definition.
 *  - Click the info icon  → opens the "Explain this metric" drawer (full copy).
 * Drop it next to any KPI, chart title, or column header by metric key:
 *    <MetricInfo metricKey="netRevenue" />
 */
const MetricInfo = ({ metricKey, position = 'top', className = '' }) => {
  const [open, setOpen] = useState(false);
  const [activeKey, setActiveKey] = useState(metricKey);
  const metric = getMetric(metricKey);

  if (!metric) return null;

  const openDrawer = () => {
    setActiveKey(metricKey);
    setOpen(true);
  };

  return (
    <>
      <SCTooltip content={metric.short} position={position}>
        <button
          type="button"
          onClick={openDrawer}
          aria-label={`Explain ${metric.label}`}
          className={`sc-question-circle inline-flex cursor-pointer items-center text-grey-darker hover:text-primary ${className}`}
        />
      </SCTooltip>
      <MetricDrawer
        metricKey={activeKey}
        isOpen={open}
        onClose={() => setOpen(false)}
        onSelectMetric={setActiveKey}
      />
    </>
  );
};

MetricInfo.propTypes = {
  metricKey: PropTypes.string.isRequired,
  position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  className: PropTypes.string,
};

export default MetricInfo;
